export enum EnvironmentName {
  Dy0 = 'DEV0',
  Dy1 = 'DEV1',
  Dy2 = 'DEV2',
  Local = 'LOCAL-DEV',
  Prod = 'PROD',
  Qy0 = 'QA0',
  Qy1 = 'QA1',
  Qy2 = 'QA2',
  Ry0 = 'RY0',
  Ry1 = 'RY1',
  Ry2 = 'RY2',
  Ry4 = 'RY4',
  Ry6 = 'RY6',
  Sy0 = 'SY0',
  SandBox = 'SANDBOX',
  Training = 'TRAINING',
};

export const baseEnvironmentConfigs = {
  loginSetting(setGcKeyUrlEn: string,
               setGcKeyUrlFr: string, setPartnerSignInUrlEn: string, setPartnerSignInUrlFr: string) {
    return {
      gcKeyUrlEn: setGcKeyUrlEn,
      gcKeyUrlFr: setGcKeyUrlFr,
      partnerSignInUrlEn: setPartnerSignInUrlEn,
      partnerSignInUrlFr: setPartnerSignInUrlFr,
    };
  },
  deploymentWarningSettings(setMaintenanceAlertPopupBefore: number, setFinalMaintenanceAlertBefore: number, setNextDeploymentPooling: number){
    return {
      maintenanceAlertPopupBefore: setMaintenanceAlertPopupBefore, //in minutes
      finalMaintenanceAlertBefore: setFinalMaintenanceAlertBefore, //in minutes
      nextDeploymentPooling: setNextDeploymentPooling,
    }
  },
  userIdleSettingsConfigs(setIdle: number, setTimeout: number, setWarningDialog: number, setTokenRefreshInterval: number) {
    return {
      idle: setIdle, // idle in seconds
      timeout: setTimeout, // timeout in seconds
      warningDialog: setWarningDialog, // show warning dialog after x seconds idle
      tokenRefreshInterval: setTokenRefreshInterval, // token refresh interval in seconds
    };
  },
  urls(baseUrl: string, carmWebServices: string, moneris: string) {
    return {
      notifications: {
        baseUrl: baseUrl + carmWebServices + '/notifications',
      },
      financial: {
        baseUrl: baseUrl + carmWebServices + '/financial',
        transactionHistory: {
          baseUrl: baseUrl + carmWebServices + '/financial/history',
        },
      },
      accessManagement: {
        baseUrl: baseUrl + carmWebServices,
      },
      accountManagement: {
        baseUrl: baseUrl + carmWebServices,
      },
      cra: {
        baseUrl: baseUrl + carmWebServices + '/cra',
      },
      rulings: {
        baseUrl: baseUrl + carmWebServices + '/rulings',
      },
      rulingsDrafts: {
        baseUrl: baseUrl + carmWebServices + '/rulingdrafts',
      },
      publicRulings: {
        baseUrl: baseUrl + carmWebServices + '/publicrulings',
      },
      programs: {
        baseUrl: baseUrl + carmWebServices + '/programs',
      },
      program: {
        baseUrl: baseUrl + carmWebServices + '/program',
        enrolment: {
          baseUrl: baseUrl + carmWebServices + '/program/enrolment',
        },
      },
      subprogramenrolment: {
        baseUrl: baseUrl + carmWebServices + '/subprogram-enrolment',
      },
      financialSecurity: {
        baseUrl: baseUrl + carmWebServices + '/financialSecurity',
      },
      business: {
        baseUrl: baseUrl + carmWebServices + '/business',
        registration: {
          baseUrl: baseUrl + carmWebServices + '/business/registration',
        },
      },
      moneris: {
        monerisUrl: moneris,
      },
      declarations: {
        // baseUrl: baseUrl + carmWebServices + '/cad',
        calculator: {
          baseUrl: baseUrl + carmWebServices + '/costcalculator',
        },
        cadMetadata: {
          baseUrl: baseUrl + carmWebServices + '/CADMetadata'
        },
        declaration: {
          baseUrl: baseUrl + carmWebServices + '/declaration',
        },
        cadDraft: {
          baseUrl: baseUrl + carmWebServices + '/caddraft',
        },
        lockSettings: {
          idle: 60, // idle in seconds
          timeout: 240, // timeout in seconds
          warningDialog: 120, // show warning dialog after x seconds idle
          heartbeat: 180
        },
        sda: {
          baseUrl: baseUrl + carmWebServices + '/sda'
        },
        massAdjustment: {
          baseUrl: baseUrl + carmWebServices + '/massadjustment'
        },
        b3: {
          baseUrl: baseUrl + carmWebServices + '/b3'
        }
      },
      roi: {
        baseUrl: baseUrl + carmWebServices + '/roi',
      },
      default: {
        baseUrl: baseUrl + carmWebServices,
      },
    };
  },
  storeConfigs(baseUrl: string, carmWebServices: string, carm: string, secret: string) {
    return {
      state: {
        storageSync: {
          keys: {
            'auth.userToken.token.refresh_token': 'LOCAL_STORAGE',
          }
        },
      },
      backend: {
        occ: {
          baseUrl,
          prefix: '/carmwebservices/v2/',
          legacy: false,
          endpoints: {
            revoke: carmWebServices + '/current/logout',
          },
        },
      },
      authentication: {
        client_id: carm,
        client_secret: secret,
      },
      features: {
        level: '1.3',
      },
      context: {
        baseSite: ['carm'],
        currency: ['CAD'],
      },
    };
  },
  httpConfig(setNumberOfTries: number, setDelayInRetry: number, setGetTimeout: number, setPostTimeout: number) {
    // handling http api call configurations
    return {
      numberOfTries: setNumberOfTries, // Number of tries
      delayInRetry: setDelayInRetry, // Number of miliseconds between each retry
      getTimeout: setGetTimeout, // Total number of miliseconds to throw timeout error (for GET requests)
      postTimeout: setPostTimeout, // Total number of miliseconds to throw timeout error (for POST requests)
    };
  },
  startDate() {
    // startdate is R2 Go-live date
    // yyyy, mm -1, dd
    return new Date(2021, 3, 14);
  }
};
